import lunr from 'lunr'
import analyze from './textAnalylzer'
import { SessionData } from './flattenCourseData'

export default function buildIndex(sessions: SessionData[]) {
  return new Promise<lunr.Index>((resolve) => {
    const idx = lunr(function () {
      this.ref('uid')

      this.field('uid')
      this.field('courseName')
      this.field('courseCode')
      this.field('courseType')
      this.field('analyzedCode')
      this.field('courseDescription')
      this.field('instructors')

      sessions.forEach((session) => {
        const instructorsList = session.instructors ?? []
        
        const doc = {
          uid: String(session.uid ?? ''),
          courseName: String(session.courseName ?? ''),
          courseCode: String(session.courseCode ?? ''),
          courseType: String(session.courseType ?? ''),
          analyzedCode: String(analyze(session.courseCode) ?? ''),
          courseDescription: String(session.courseDescription ?? ''),
          instructors: instructorsList.length
            ? instructorsList.map(
                (instructor) =>
                  `${String(instructor.firstname ?? '')} ${String(instructor.lastname ?? '')}`
              ).join(', ')
            : '',
        }
        this.add(doc)
      }, this)
    })

    resolve(idx)
  })
}
